import { type Components, darken } from "@mui/material";
import type { themeBBJ } from "../material.theme";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    filter: true;
    "contained-reverse": true;
  }
  interface ButtonPropsColorOverrides {
    blue: true;
  }
}

export const MuiButton: Components<typeof themeBBJ>["MuiButton"] = {
  styleOverrides: {
    sizeSmall: {
      height: 32,
    },
    root: {
      variants: [
        {
          props: { variant: "filter" },
          style: ({ theme }) => ({
            backgroundColor: "white",
            border: `solid 1px ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
            padding: `${theme.spacing(0.5)} ${theme.spacing(1.75)}`,
            textTransform: "none",
            height: 32,
            ...theme.typography.body1,
          }),
        },
        {
          props: { variant: "contained-reverse", color: "secondary" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.secondary.contrastText,
            color: theme.palette.secondary.main,
            "&:hover": {
              backgroundColor: darken(theme.palette.secondary.contrastText, 0.1),
            },
          }),
        },
        {
          props: { variant: "contained-reverse", color: "blue" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.blue.contrastText,
            color: theme.palette.blue.main,
            "&:hover": {
              backgroundColor: darken(theme.palette.blue.contrastText, 0.1),
            },
          }),
        },
      ],
      borderRadius: "0px",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      },
    },
    outlinedPrimary: {
      border: "2px solid #5A5B90",
      ":hover": {
        border: "2px solid #5A5B90",
      },
    },
    outlinedSizeSmall: {
      padding: "2px 8px",
    },
    outlinedSizeMedium: {
      padding: "4px 14px",
    },
    outlinedSizeLarge: {
      padding: "6px 20px",
    },
  },
};
